<section class="py-7">
  <div class="bg-gray-light desk:bg-transparent">
    <div
      class="centered-1170-with-padding flex flex-col gap-1.5 px-4 py-12 desk:rounded-[45px] desk:bg-gray-light desk:px-11 desk:py-10">
      <app-title [title]="data.title" size="custom-35-device-agnostic" />
      @if (data.text) {
        <span [innerHTML]="data.text" handleHtmlLinks></span>
      }
      @if (data.pictos) {
        <div class="mt-5 flex flex-wrap items-center justify-center gap-y-2.5 desk:gap-x-8">
          @for (picto of data.pictos; track $index) {
            <div class="box-content w-1/2 desk:w-[calc(20%_-_1.6rem)]">
              <div class="mx-auto max-w-52 p-1.5">
                @if (picto) {
                  <app-image
                    [image]="picto"
                    [isPriority]="!isImageInPreviousBlocks && $index < 5"
                    [keepAspectRatio]="true" />
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</section>
